import React from "react";
import img1 from "../../assets/images/img2.webp";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <section className="relative isolate pt-24 sm:pt-28 lg:pt-32 pb-12 sm:pb-16 overflow-hidden bg-white">
      <div className="absolute inset-0 -z-10 h-full w-full bg-[radial-gradient(circle_at_50%_50%,rgba(230,57,70,0.05),transparent_70%)]"></div>

      <div className="mx-auto w-[95%] md:w-[90%]">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-12 items-center justify-between">
          {/* LEFT */}
          <div className="flex flex-col w-full max-w-2xl text-center lg:text-left pt-2 lg:pt-0">
            <h1 className="text-3xl xs:text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-[#0B1C2D] leading-[1.15] animate-fade-in-up">
              Build Smart Forms.{" "}
              <br className="hidden sm:block" />
              <span className="text-[#E63946] bg-clip-text text-transparent bg-gradient-to-r from-[#E63946] to-[#ff6b6b]">
                Manage Every Message.
              </span>
            </h1>

            <p className="mt-5 sm:mt-6 text-base sm:text-lg leading-7 sm:leading-8 text-[#64748B] max-w-lg mx-auto lg:mx-0 animate-fade-in-up [animation-delay:100ms]">
              Your smart form generator and centralized inbox. Create
              professional forms faster and manage submissions from one simple
              dashboard — no backend, no chaos.
            </p>

            <div className="mt-8 sm:mt-10 flex flex-col sm:flex-row items-stretch sm:items-center justify-center lg:justify-start gap-3 sm:gap-4 animate-fade-in-up [animation-delay:200ms]">
              <Link
                to="/register"
                className="rounded-lg bg-[#E63946] px-8 sm:px-12 py-3.5 text-base font-semibold text-white text-center shadow-md shadow-[#E63946]/20 hover:bg-[#d12f3c] hover:-translate-y-1 hover:shadow-xl transition-all duration-300"
              >
                Start Free
              </Link>
            </div>

            <div className="mt-8 sm:mt-10 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 sm:gap-4 text-sm text-[#64748B] animate-fade-in-up [animation-delay:300ms]">
              <div className="flex -space-x-2 shrink-0">
                {[0, 1, 2, 3, 4, 5].map((i) => (
                  <img
                    key={i}
                    alt=""
                    className="inline-block h-7 w-7 sm:h-8 sm:w-8 rounded-full ring-2 ring-white object-cover"
                    src={`https://i.pravatar.cc/150?u=${i}`}
                  />
                ))}
              </div>
              <span className="font-medium text-[#0B1C2D] text-center sm:text-left">
                Trusted by 100+ teams across India
              </span>
            </div>
          </div>

          {/* RIGHT */}
          <div className="relative w-full lg:w-1/2 opacity-0 animate-fade-in-up [animation-delay:400ms] px-2 sm:px-0">
            <div className="relative rounded-xl bg-white border border-[#E2E8F0] p-1.5 sm:p-2 shadow-2xl shadow-slate-200/50">
              <div className="absolute -top-12 -right-12 -z-10 w-[200px] sm:w-[300px] h-[200px] sm:h-[300px] bg-[#E63946]/10 blur-[100px] rounded-full"></div>

              <img
                alt="ContactHQ dashboard preview"
                className="rounded-lg w-full object-cover shadow-inner min-h-[220px] sm:min-h-[320px] lg:min-h-[400px] max-h-[480px] block"
                src={img1}
                onError={(e) => {
                  e.target.src =
                    "https://via.placeholder.com/600x400?text=Check+Image+Path";
                }}
              />

              <div className="absolute bottom-3 left-3 sm:-bottom-4 sm:-left-4 bg-white border border-[#E2E8F0] p-3 sm:p-4 rounded-lg shadow-xl flex items-center gap-2 sm:gap-3 max-w-[calc(100%-1.5rem)] sm:max-w-none">
                <div className="bg-red-50 p-1.5 sm:p-2 rounded-full text-[#E63946] shrink-0">
                  <span className="material-symbols-outlined text-lg sm:text-2xl">
                    check_circle
                  </span>
                </div>
                <div className="min-w-0">
                  <p className="text-[10px] sm:text-xs text-[#64748B] font-medium truncate">
                    Tickets Resolved
                  </p>
                  <p className="text-sm sm:text-lg font-bold text-[#0B1C2D]">
                    +142%{" "}
                    <span className="text-[10px] sm:text-xs font-normal text-[#64748B]">
                      this week
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
